import type { SocialLogin } from '../../../../../../../../../api/cognito/getSocialLoginUrl';
import { SIGNUP_METHODS } from '../../../../../../../../../constants/constants';
import type { Sender } from '../../../../../../../../../interfaces/machines';
import type { Events } from '../../../../../machine/types';

const DEFAULT_WINDOW_WIDTH = 520;

export const sendOAuthSignUpEvent = (
  platform: SocialLogin,
  method: (typeof SIGNUP_METHODS)[keyof typeof SIGNUP_METHODS],
  send: Sender<Events>,
  windowWidth: number = DEFAULT_WINDOW_WIDTH,
): void => {
  send({ type: 'SIGNUP_VIA_OAUTH', data: { OAuth: { platform, method, windowWidth } } });
};
